import { Stack, Typography } from '@mui/material';
import { ReactNode } from 'react';

import { Card } from '@/components/layout/Card/Card';

interface AccessCardProps {
  heading?: ReactNode;
  subheading?: ReactNode;
  children?: ReactNode;
}

export function AccessCard({ heading, subheading, children }: AccessCardProps) {
  return (
    <Card variant="filled" sx={{ p: 2 }}>
      <Stack spacing={2}>
        {(heading || subheading) && (
          <Stack spacing={0.5}>
            {heading && (
              <Typography variant="title-s" component="div">
                {heading}
              </Typography>
            )}
            {subheading && (
              <Typography variant="body-xs">{subheading}</Typography>
            )}
          </Stack>
        )}
        {children}
      </Stack>
    </Card>
  );
}
